import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IStoreData } from './interface/store-data.interface';

@Injectable({ providedIn: 'root' })
export class AnimationService {
    animation: string = '';

    constructor(private store: Store<{ index: IStoreData }>) {
        this.store
            .select((d) => d.index.animation)
            .subscribe((animation: string) => {
                this.animation = animation;
            });
    }

    initAnimation() {
        this.changeAnimation();
    }

    changeAnimation(type: 'add' | 'remove' = 'add') {
        if (this.animation) {
            const ele: any = document.querySelector('.animation');
            if (type === 'add') {
                ele?.classList.add('animate__animated');
                ele?.classList.add(this.animation);
            } else {
                ele?.classList.remove('animate__animated');
                ele?.classList.remove(this.animation);
            }
        }
    }
}
